import { type FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import type { postMagazineOnelineMenuContentQuery } from "scmp-app/queries/__generated__/postMagazineOnelineMenuContentQuery.graphql";

import IconArrowDarkGray from "./icon-arrow-dark-gray.svg";
import {
  Container,
  StyledHeaderOnelineMenuContainer,
  StyledPostMagazineOnelineMenu,
} from "./styles";

type Props = HeaderFeatureCommonProps;

export const PostMagazineOnelineMenuContent: FunctionComponent<Props> = props => {
  const queryReference = useLazyLoadQuery<postMagazineOnelineMenuContentQuery>(
    graphql`
      query postMagazineOnelineMenuContentQuery {
        postMagSection: section(filter: { entityId: "71" }) {
          subSections {
            items {
              edges {
                ...entityOnelineMenuQueueItemsEdge
              }
            }
          }
        }
      }
    `,
    {},
  );

  return (
    <Container {...getResponsiveProps(props)}>
      <StyledPostMagazineOnelineMenu
        reference={queryReference.postMagSection?.subSections?.items?.edges ?? []}
      />
      <StyledHeaderOnelineMenuContainer
        icon={IconArrowDarkGray}
        isShowFullList={false}
        isShowPrefixHyphen={false}
      />
    </Container>
  );
};

PostMagazineOnelineMenuContent.displayName = "PostMagazineOnelineMenuContent";
